import { Components, Theme } from '@mui/material/styles';

export default (): Components<Theme>['MuiInputLabel'] => ({
  styleOverrides: {
    root: {
      fontSize: '1rem',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      fontWeight: '400'
    }
  }
});
